export default __webpack_public_path__ + "static/media/nea-update.0d9b60d5.png";